// Iterative tri-color DFS used to validate Sankey input. Sankey is
// inherently a DAG; finding a cycle lets the artifact render a clear
// error rather than letting the chart layout blow up downstream.
export function findSankeyCycle(
  nodeCount: number,
  links: Array<{ source: number; target: number }>,
): number[] | null {
  const adjacency: number[][] = Array.from({ length: nodeCount }, () => [])
  for (const link of links) {
    if (link.source === link.target) return [link.source, link.source]
    adjacency[link.source].push(link.target)
  }

  const WHITE = 0
  const GRAY = 1
  const BLACK = 2
  const color = new Array<number>(nodeCount).fill(WHITE)
  const parent = new Array<number>(nodeCount).fill(-1)

  function dfs(start: number): number[] | null {
    const stack: Array<{ node: number; cursor: number }> = [
      { node: start, cursor: 0 },
    ]
    color[start] = GRAY
    while (stack.length > 0) {
      const frame = stack[stack.length - 1]
      const neighbors = adjacency[frame.node]
      if (frame.cursor >= neighbors.length) {
        color[frame.node] = BLACK
        stack.pop()
        continue
      }
      const neighbor = neighbors[frame.cursor++]
      if (color[neighbor] === GRAY) {
        const path = [neighbor]
        let current = frame.node
        while (current !== neighbor && current !== -1) {
          path.push(current)
          current = parent[current]
        }
        path.push(neighbor)
        path.reverse()
        return path
      }
      if (color[neighbor] === WHITE) {
        parent[neighbor] = frame.node
        color[neighbor] = GRAY
        stack.push({ node: neighbor, cursor: 0 })
      }
    }
    return null
  }

  for (let i = 0; i < nodeCount; i++) {
    if (color[i] === WHITE) {
      const cycle = dfs(i)
      if (cycle) return cycle
    }
  }
  return null
}
